import { colors } from '../../colors';
var jumplink = {
  bgColor: colors.whiteish,
  borderColor: colors.overcast,
  linkColor: colors.cerulean
};
export default jumplink;